import React from 'react';
import { createPortal } from 'react-dom';
import { getTeamUrl } from '../../utilities/urlHelper';
import SuggestionEditForm from '../suggestions/SuggestionEditForm';

const PageUpdateSuggestionModal = ({ closeModal, suggestion }) => {
    const onClickModal = ({ target }) => {
        const className = target.getAttribute('class');
        if (closeModal && className && className.includes('react-modal open')) {
            closeModal();
        }
    };

    return (
        <div className="react-modal open suggest-update-modal" onMouseDown={onClickModal}>
            <div className="modal-content p2">
                <form method="POST" action={`${getTeamUrl()}/page-requests/${suggestion.id}`} id="settings-form">
                    <input name="_method" type="hidden" value="PUT" />
                    <input name="_token" type="hidden" value={window.csrfToken} />
                    <div id="suggestion-edit-container" className="form-group">
                        <SuggestionEditForm
                            title={suggestion.title}
                            description={suggestion.description}
                            assignableId={suggestion.assignable_id}
                            assignableSlackId={suggestion.assignable.slack_id ? suggestion.assignable.slack_id : null}
                            assignableType={suggestion.assignable_type}
                            categoryId={suggestion.category_id}
                            folderId={suggestion.folder_id}
                            templateId={suggestion.template_id}
                            pageId={suggestion.page_id}
                            edit
                        />
                    </div>
                </form>
            </div>
        </div>
    );
};

export default (props) => createPortal(<PageUpdateSuggestionModal {...props} />, document.body);
